import * as React from 'react';

import i18n from 'helper/i18n';

import Intensity from 'components/atoms/Intensity';

import { ContentTypePoolWorkoutDtoType } from 'types/services/magnolia/dtos/ContentTypePoolWorkoutDto';

export const FILTER_ID = 'WORKOUT_INTENSITY' as const;

export const FILTER_FACTORY = {
	LOW: (item: ContentTypePoolWorkoutDtoType) => item.intensity === 1,
	MEDIUM: (item: ContentTypePoolWorkoutDtoType) => item.intensity === 2,
	HIGH: (item: ContentTypePoolWorkoutDtoType) => item.intensity === 3,
};

export const FILTER: { [key: string]: keyof typeof FILTER_FACTORY } = {
	LOW: 'LOW',
	MEDIUM: 'MEDIUM',
	HIGH: 'HIGH',
};

export const FILTER_LABELS: { [key: string]: React.ReactNode } = {
	LOW: (
		<React.Fragment>
			{i18n(`react.impulsCoach.components.tagFilter.workout.${FILTER_ID}.${FILTER.LOW}`)}
			<div className="m-tag-filter__addition">
				<Intensity value={1} modifier="dark" />
			</div>
		</React.Fragment>
	),
	MEDIUM: (
		<React.Fragment>
			{i18n(`react.impulsCoach.components.tagFilter.workout.${FILTER_ID}.${FILTER.MEDIUM}`)}
			<div className="m-tag-filter__addition">
				<Intensity value={2} modifier="dark" />
			</div>
		</React.Fragment>
	),
	HIGH: (
		<React.Fragment>
			{i18n(`react.impulsCoach.components.tagFilter.workout.${FILTER_ID}.${FILTER.HIGH}`)}
			<div className="m-tag-filter__addition">
				<Intensity value={3} modifier="dark" />
			</div>
		</React.Fragment>
	),
};

export const FILTER_RADIO_LABELS: { [key: string]: React.ReactNode } = {
	LOW: <Intensity value={1} modifier="list" />,
	MEDIUM: <Intensity value={2} modifier="list" />,
	HIGH: <Intensity value={3} modifier="list" />,
};

export function filterForIntensity(
	filter: /* TODO: $Values<typeof FILTER> */ any
): (item: ContentTypePoolWorkoutDtoType) => boolean {
	return (item: ContentTypePoolWorkoutDtoType) => FILTER_FACTORY[filter](item);
}
